import {ReviewUserTopicFieldEnum, ReviewUserTopicType} from './review-user-topics-type';

export const emptyReviewUserTopic: Omit<ReviewUserTopicType, 'id'> = {
    [ReviewUserTopicFieldEnum.name]: '',
    [ReviewUserTopicFieldEnum.includeTags]: [],
    [ReviewUserTopicFieldEnum.excludeTags]: [],
    [ReviewUserTopicFieldEnum.brands]: [],
};
